import { ROUTE_NAMES } from '$router/config'
import Navigate from '$router/Navigate'

const GlobalDashboardUserIndexPage = () => {
  return (
    <Navigate
      to={ROUTE_NAMES.GLOBAL_MEMBER_ACCESS_APPS}
      options={options => ({ ...options, replace: true })}
    />
  )
}

export default GlobalDashboardUserIndexPage
